module.exports = __webpack_public_path__ + "static/media/card-Charlie-handsFree-inactive.b662d590.svg";